import React, {useState, useEffect} from 'react'
import {inject, observer} from 'mobx-react'
import {getLocationEnergy, getAreaStatistics} from '@apis'
import * as G2 from '@antv/g2'

const EnergyConsumption = inject('store')(
  observer(({store}) => {
    const {userInfo = {}} = store
    const {strongProjectId: projectId, brokerId} = userInfo

    async function queryAreaStatistic() {
      const params = {
        projectId,
        brokerId,
        pageNo: 1,
        pageSize: 999,
        dimension: 3,
      }
      const res = projectId ? await getAreaStatistics(params) : await getLocationEnergy(params)
      if (res && res.data) {
        const total = res.data.reduce((all, currentValue) => {
          return currentValue.energy + all
        }, 0)
        const energyArr = res.data.map((item, index) => {
          const dataObj = {
            areaName: item.areaName,
            count: item.energy,
            percent: total ? item.energy / total : (index+1)*0.1
          }
          return dataObj
        })
        creatChat(energyArr)
      }
    }

    useEffect(() => {
      queryAreaStatistic()
    }, [])
   
    function creatChat(data) {
      const chart = new G2.Chart({
        container: 'consumption-container',
        autoFit: true,
        height: 260,
      });
      chart.data(data);
      chart.scale('percent', {
        formatter: (val) => {
          val = val * 100 + '%';
          return val;
        },
      });
      chart.coordinate('theta', {
        radius: 0.75,
        innerRadius: 0.7,
      });
      chart.tooltip({
        showTitle: false,
        showMarkers: false,
        itemTpl: '<li class="g2-tooltip-list-item"><span style="background-color:{color};" class="g2-tooltip-marker"></span>{name}: {value}</li>',
      });
      chart
        .interval()
        .adjust('stack')
        .position('percent')
        .color('areaName')
        .label('percent', (percent) => {
          return {
            content: (data) => {
              return `${data.areaName}: ${(percent * 100).toFixed(0)}%`;
            },
            style: {
              fill: '#fff',
              fontSize: 14
            }
          };
        })
        .tooltip('areaName*percent', (areaName, percent) => {
          percent = (percent * 100).toFixed(0) + '%';
          return {
            name: areaName,
            value: percent,
          };
        });
      chart.legend(false);
  
      chart.interaction('element-active');
  
      chart.render();
    }

    return (
      <div className='ck-energy-consumption'>
        <div className='title'>区域能耗占比</div>
        <div className='consumption-item'>
          <div id='consumption-container' className='consumption-chat'></div>
        </div>
      </div>
    )
  })
)

export default EnergyConsumption
